import React from 'react';
import {useParams} from 'react-router-dom'
import OrdenesList from './OrdenesList';
import Historial from './Historial';
import Precios from './Precios';
const Ordenes = (props) => {
    let { idRuta } = useParams();
    if(idRuta==="pendientes")  {return <OrdenesList {...props}/>}
    if(idRuta==="historial")    return <Historial {...props}/>
    if(idRuta==="precios")      return <Precios {...props}/>

    else{
        return <OrdenesList {...props}/>
    }
};

export default Ordenes;